var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-price-range"},[_c('span',{staticClass:"c-price-title"},[_vm._v("公司动态")]),_c('div',{staticClass:"price-desc"},[_vm._v("\n    "+_vm._s(_vm.footerdesc)+"\n    \n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }